import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dialog-confirm',
 
  templateUrl: './dialog-confirm.component.html',
  styleUrl: './dialog-confirm.component.css'
})
export class DialogConfirmComponent {
  constructor(private readonly router: Router) {
}
  redirectToAnotherRoute() {
    this.router.navigate(['login']);
 
  }
}
